import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export function useGetRouterConfig(dataPoolId: string, enabled: boolean = false) {
  const glynt = useGlynt();

  return useQuery({
    queryKey: ['data-pool-route-config', dataPoolId],
    queryFn: async () => (await glynt).dataPool.retrieveRouteConfig(dataPoolId),
    enabled,
    refetchOnWindowFocus: false,
    retry: 1
  });
}
